<template>
  <div>
    <page-title icon="fas fa-chart-pie" main="Avaliação COM"> </page-title>

    <div class="card mt-2" style="padding: 0rem 1rem">
      <div class="row">
        <div  class="col-lg-12 card-header">
              <h5 class="h3 mb-0">Avaliação COM</h5>
              <h6 class="text-uppercase text-muted ls-1 mb-1">  Configure quais dados deverão ser listados:  </h6>
            </div>
        <div class="col-md-3 mt-3 mb-3">
          <label class="form-control-label">Cargo</label>
          <multiselect
            v-model="filterRole"
            :select-label="''"
            :deselect-label="''"
            :selected-label="'Selecionado'"
            :options="roles || []"
            label="name"
            placeholder="Selecionar Grupo"
          />
        </div>

        <div class="col-md-3 mt-3 mb-3">
          <label class="form-control-label">Data</label>
          <multiselect
            v-model="anoParticipation"
            :options="participation"
            :select-label="''"
            :deselect-label="''"
            :selected-label="'Selecionado'"
            placeholder="Selecionar Data"
            label="descricao"
          />
        </div>

        <div class="col-md-3 mt-5 mb-3">
          <base-button icon type="info" @click="clickedEvaluate">
            <span class="btn-inner--icon">
              <i class="fas fa-search"></i>
            </span>
            <span class="btn-inner--text"><strong>Pesquisar</strong></span>
          </base-button>
          <base-button
            type="secondary"
            class="mr-2"
            @click="clearFilters">
            Limpar Filtros
          </base-button>
        </div>
      </div>
    </div>

    <card v-if="hide">
      <h3>METAS QUANTITATIVAS</h3>
      <br />
      <el-table
        v-loading = "isLoading"
        class="table-responsive table-flush"
        header-row-class-name="thead-light"
        :data="descriptionQuantitatives"
        stripe="stripe"
        border
        style="width: 100%"
      >
        <el-table-column label="Metas" prop="description" max-width="30px" sortable>
           <template slot-scope="scope">
            <div v-if="outOfDate">
              <el-tooltip content="Fora de período de avaliações" placement="top">
                <el-input
                  v-model="scope.row.description"
                  @change="handleEditRow(scope.row)"
                  :disabled="outOfDate"
                >
                </el-input>
              </el-tooltip>
            </div>
            <div v-else slot-scope="scope">
              <el-input
                v-model="scope.row.description"
                @change="handleEditRow(scope.row)"
              >
              </el-input>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Peso" prop="weight" min-width="15px" sortable>
           <template slot-scope="scope">
            <div v-if="outOfDate">
              <el-tooltip content="Fora de período de avaliações" placement="top">
                <el-input
                  v-model="scope.row.weight"
                  @change="handleEditRow(scope.row)"
                  :disabled="outOfDate"
                >
                </el-input>
              </el-tooltip>
            </div>
            <div v-else slot-scope="scope">
              <el-input
                v-model="scope.row.weight"
                @change="handleEditRow(scope.row)"
              >
              </el-input>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Nota" prop="grade" min-width="15px" sortable>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.grade"
              @change="handleEditRow(scope.row)"
              :disabled="true"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column label="Pontos" prop="points" min-width="15px" sortable>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.points"
              :disabled="true"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column label="Total" prop="total" min-width="15px" sortable>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.total"
              :disabled="true"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="Opções" min-width="10px"  v-slot="{ row }">
          <div class="row ml-2">
            <el-dropdown
              trigger="hover"
              class="dropdown"
              style="cursor: pointer"
            >
              <span class="btn btn-sm btn-icon-only text-info">
                <i class="fas fa-ellipsis-v mt-2"></i>
              </span>
              <el-dropdown-menu
                class="dropdown-menu dropdown-menu-arrow show"
                slot="dropdown"
              >
                <a class="dropdown-item" href="#" @click="addQuantitative(row)">Adicionar</a>
                <a class="dropdown-item" href="#" @click="removeQuantitative(row)"
                  >Excluir</a
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-table-column>
      </el-table>
       <br>
      <a v-if="!this.quantitativeGoals.length" href="#" @click="addQuantitative(row)" style="color:#8898aa">Adicionar</a>
    </card>

    <card v-if="hide">
      <h3>METAS PESSOAIS</h3>
      <br />
      <el-table
        v-loading = "isLoading"
        class="table-responsive table-flush"
        header-row-class-name="thead-light"
        :data="descriptionsPessoal"
        stripe="stripe"
        border
        style="width: 100%"
      >
        <el-table-column label="Metas" prop="description" max-width="30px" sortable>
           <template slot-scope="scope">
            <div v-if="outOfDate">
              <el-tooltip content="Fora de período de avaliações" placement="top">
                <el-input
                  v-model="scope.row.description"
                  @change="handleEditRow(scope.row)"
                  :disabled="outOfDate"
                >
                </el-input>
              </el-tooltip>
            </div>
            <div v-else slot-scope="scope">
              <el-input
                v-model="scope.row.description"
                @change="handleEditRow(scope.row)"
              >
              </el-input>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Peso" prop="weight" min-width="15px" sortable>
           <template slot-scope="scope">
            <div v-if="outOfDate">
              <el-tooltip content="Fora de período de avaliações" placement="top">
                <el-input
                  v-model="scope.row.weight"
                  @change="handleEditRow(scope.row)"
                  :disabled="outOfDate"
                >
                </el-input>
              </el-tooltip>
            </div>
            <div v-else slot-scope="scope">
              <el-input
                v-model="scope.row.weight"
                @change="handleEditRow(scope.row)"
              >
              </el-input>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Nota" prop="grade" min-width="15px" sortable>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.grade"
              @change="handleEditRow(scope.row)"
              :disabled="true"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column label="Pontos" prop="points" min-width="15px" sortable>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.points"
              :disabled="true"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column label="Total" prop="total" min-width="15px" sortable>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.total"
              :disabled="true"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="Opções" min-width="10px"  v-slot="{ row }">
          <div class="row ml-2">
            <el-dropdown
              trigger="hover"
              class="dropdown"
              style="cursor: pointer"
            >
              <span class="btn btn-sm btn-icon-only text-info">
                <i class="fas fa-ellipsis-v mt-2"></i>
              </span>
              <el-dropdown-menu
                class="dropdown-menu dropdown-menu-arrow show"
                slot="dropdown"
              >
                <a class="dropdown-item" href="#" @click="addPersonal(row)">Adicionar</a>
                <a class="dropdown-item" href="#" @click="removePersonal(row)"
                  >Excluir</a
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-table-column>
      </el-table>
      <br/>
      <a v-if="!this.personalGoals.length" href="#" @click="addPersonal(row)" style="color:#8898aa">Adicionar</a>
    </card>

    <card v-if="hide">
      <h3>METAS QUALITATIVAS</h3>
      <br />
      <el-table
        v-loading = "isLoading"
        class="table-responsive table-flush"
        header-row-class-name="thead-light"
        :data="descriptionQualitatives"
        stripe="stripe"
        border
        style="width: 100%"
      >
        <el-table-column label="Metas" prop="description" max-width="30px" sortable>
           <template slot-scope="scope">
            <div v-if="outOfDate">
              <el-tooltip content="Fora de período de avaliações" placement="top">
                <el-input
                  v-model="scope.row.description"
                  @change="handleEditRow(scope.row)"
                  :disabled="outOfDate"
                >
                </el-input>
              </el-tooltip>
            </div>
            <div v-else slot-scope="scope">
              <el-input
                v-model="scope.row.description"
                @change="handleEditRow(scope.row)"
              >
              </el-input>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Peso" prop="weight" min-width="15px" sortable>
            <template slot-scope="scope">
            <div v-if="outOfDate">
              <el-tooltip content="Fora de período de avaliações" placement="top">
                <el-input
                  v-model="scope.row.weight"
                  @change="handleEditRow(scope.row)"
                  :disabled="outOfDate"
                >
                </el-input>
              </el-tooltip>
            </div>
            <div v-else slot-scope="scope">
              <el-input
                v-model="scope.row.weight"
                @change="handleEditRow(scope.row)"
              >
              </el-input>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Nota" prop="grade" min-width="15px" sortable>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.grade"
              @change="handleEditRow(scope.row)"
              :disabled="true"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column label="Pontos" prop="points" min-width="15px" sortable>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.points"
              :disabled="true"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column label="Total" prop="total" min-width="15px" sortable>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.total"
              :disabled="true"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="Opções" min-width="10px"  v-slot="{ row }">
          <div class="row ml-2">
            <el-dropdown
              trigger="hover"
              class="dropdown"
              style="cursor: pointer"
            >
              <span class="btn btn-sm btn-icon-only text-info">
                <i class="fas fa-ellipsis-v mt-2"></i>
              </span>
              <el-dropdown-menu
                class="dropdown-menu dropdown-menu-arrow show"
                slot="dropdown"
              >
                <a class="dropdown-item" href="#" @click="addQualitative(row)">Adicionar</a>
                <a class="dropdown-item" href="#" @click="removeQualitative(row)"
                  >Excluir</a
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-table-column>
      </el-table>
      <br>
      <a v-if="!this.qualitativeGoals.length" href="#" @click="addQualitative(row)" style="color:#8898aa">Adicionar</a>
    </card>
  </div>
</template>

<script>
import Vue from "vue";
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import Modal from "@/components/Modal";
import { DatePicker } from "element-ui";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";

export default {
  name: "app",
  components: {
    PageTitle,
    Multiselect,
    Modal,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      hide: false,
      roles: "",
      filterRole: "",
      participation: [],
      isLoading: false,
      anoParticipation: "",
      teste_1: false,
      quantitativeGoals: [],
      personalGoals: [],
      qualitativeGoals: [],
      resultGoals: [],
      editMode: false,
      refresh: false,
      descriptionQuantitatives : [],
      descriptionsPessoal : [],
      descriptionQualitatives : [],
      outOfDate: false,
    };
  },
  mounted() {
    this.initValues();
    this.getUsers();
    this.getParticipation();
  },
  methods: {
    clickedEvaluate() {
      if (!this.filterRole) {
        this.$toasted.global.defaultError({msg: 'Insira um usuário !'})
        return
      }
      if (!this.anoParticipation) {
        this.$toasted.global.defaultError({msg: 'Insira um ano PPR !'});
        return
      }
      this.hide = true;
      this.getAvaliation();
    },
    getUsers() {
      this.$http.secured.get("/api/v1/roles")
        .then((response) => {
          console.log(response)
          this.roles = response.data.roles
          console.log(this.roles)
        });
    },
    clickedReview(){
      this.teste_1 = true;
    },
    async checkDates() {
      const response = await this.$http.secured.get("/api/v1/admin/settings")
      try {
        let finalDateAvaliation = moment(response.data.avaliation_review.end_date.value).format('L')
        this.outOfDate = new Date() > new Date(finalDateAvaliation) ? true : false
      }
      catch(error) { console.log(error) }
    },
    initValues(){
      console.log(this.$route)
      console.log(this.$route.params)
      if(this.$route.params.role_id) this.filterRole.id = this.$route.params.role_id
      if(this.$route.params.participation_ppr_id) this.anoParticipation.id = this.$route.params.participation_ppr_id
      // exemplo de rota com parâmetro
    },
    getParticipation() {
      this.$http.secured
        .get(`/api/v1/admin/participation_pprs`, { params: { unpaged: true } })
        .then((response) => {
          this.participation = response.data;
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    handleEditRow(avaliation_resume) {
      if(!this.editMode)
        this.$http.secured
          .put(`/api/v1/avaliation_withs/${avaliation_resume.id}`, avaliation_resume )
          .then(response => {
            this.$toasted.global.defaultSuccess();
            this.getAvaliation()
          })
          .catch(error => console.log(error));
    },
    removeQuantitative(quantitative) {
      this.$http.secured
        .delete(`/api/v1/avaliation_withs/${quantitative.id}`, quantitative)
        .then((response) => {
          console.log("response: ", response.data);
          this.getAvaliation();
          this.$toasted.global.defaultSuccess();
        })
        .catch((error) => {
          this.setError(error, "Cannot remove quantitative");
          this.$refs.observer.setErrors(this.errors);
        });
    },
    addQuantitative(quantitative) {
      let newRow  = {
        weight: 0,
        description:'Nova',
        kind: 'METAS QUANTITATIVAS',
        grade: 0,
        total: 0,
        points: 0,
        participation_ppr_id: this.anoParticipation.id,
        role_id: this.filterRole.id,
        is_file: true
      };
      this.$http.secured
        .post(`/api/v1/avaliation_withs`, newRow)
        .then((response) => {
          console.log("response: ", response.data);
          this.getAvaliation();
          this.$toasted.global.defaultSuccess();
        })
        .catch((error) => {
          this.setError(error, "Cannot remove quantitative");
          this.$refs.observer.setErrors(this.errors);
          // this.$toasted.global.defaultError();
        });
    },
    removePersonal(personal) {
      this.$http.secured
        .delete(`/api/v1/avaliation_withs/${personal.id}`, personal)
        .then((response) => {
          console.log("response: ", response.data);
          this.getAvaliation();
          this.$toasted.global.defaultSuccess();
        })
        .catch((error) => {
          this.setError(error, "Cannot remove personal");
          // this.$toasted.global.defaultError();
          this.$refs.observer.setErrors(this.errors);
        });
    },
    addPersonal(personal) {
      let newRow  = {
        kind: "METAS PESSOAIS",
        description:"Nova",
        weight: 0,
        grade: 0,
        points: 0*10,
        total: 0* 0,
        role_id: this.filterRole.id,
        participation_ppr_id: this.anoParticipation.id,
        is_file: true
      };
      this.$http.secured
        .post(`/api/v1/avaliation_withs`, newRow)
        .then((response) => {
          console.log("response: ", response.data);
          this.getAvaliation();
          this.$toasted.global.defaultSuccess();
        })
        .catch((error) => {
          this.setError(error, "Cannot remove personal");
          this.$refs.observer.setErrors(this.errors);
          // this.$toasted.global.defaultError();
        });
    },
    removeQualitative(qualitative) {
      this.$http.secured
        .delete(`/api/v1/avaliation_withs/${qualitative.id}`, qualitative)
        .then((response) => {
          console.log("response: ", response.data);
          this.getAvaliation();
          this.$toasted.global.defaultSuccess();
        })
        .catch((error) => {
          this.setError(error, "Cannot remove qualitative");
          // this.$toasted.global.defaultError();
          this.$refs.observer.setErrors(this.errors);
        });
    },
    addQualitative(qualitative) {
      let newRow  = {
        kind: "METAS QUALITATIVAS",
        description: "Nova",
        weight:0,
        grade:0,
        points:0*10,
        total:0,
        role_id: this.filterRole.id,
        participation_ppr_id: this.anoParticipation.id,
        is_file: true
      };
      this.$http.secured
        .post(`/api/v1/avaliation_withs`, newRow)
        .then((response) => {
          console.log("response: ", response.data);
          this.getAvaliation();
          this.$toasted.global.defaultSuccess();
        })
        .catch((error) => {
          this.setError(error, "Cannot remove qualitative");
          this.$refs.observer.setErrors(this.errors);
          // this.$toasted.global.defaultError();
        });
    },
    getAvaliation() {
      this.isLoading = true;
      console.log(this.filterRole)
      var dataAvaliation = {
        q: {
          participation_ppr_id: this.anoParticipation.id,
          role_id: this.filterRole.id,
        },
      };
      this.$http.secured
        .get(`/api/v1/avaliation_withs`, { params: dataAvaliation })
        .then((response) => {
          this.avaliations = response.data
          this.descriptionQuantitatives = this.avaliations.filter(avaliation => avaliation.kind == "METAS QUANTITATIVAS")
          this.descriptionsPessoal      = this.avaliations.filter(avaliation => avaliation.kind == "METAS PESSOAIS")
          this.descriptionQualitatives  = this.avaliations.filter(avaliation => avaliation.kind == "METAS QUALITATIVAS")
          this.isLoading = false;
        })
        .catch((error) => console.log(error));
    },
    clearFilters() {
      this.filterRole = "",
      this.anoParticipation = ""
    },
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    }
  },
  watch: {
    'refresh': function() {
      this.$toasted.global.defaultSuccess({msg: 'Avaliação criada ! '});
      setTimeout(function(){
        location.reload();
      }, 1000);
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
